var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cards-section"},[_c('div',{staticClass:"card-grid"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.id,staticClass:"action-card"},[(card.icon)?_c('i',{staticClass:"action-icon icon-glow",class:card.icon}):_vm._e(),_c('span',{staticClass:"action-label"},[_vm._v(_vm._s(card.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }